export default __webpack_public_path__ + "images/assets/6f5d534093eb66614fbffd5d0e4ee589.svg";